"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var users;
        (function (users) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.dtColCount = 0;
                        this.userTypes = [];
                        this.userStatuses = [];
                        this.userPermissionManageUsers = false;
                        this.exportUserRows = appn.emptyString;
                        this.usersCreate = appn.emptyString;
                        this.usersIndex = appn.emptyString;
                        this.userId = 0;
                        this.canSeeCheckboxes = false;
                        this.providerType = appn.emptyString;
                        this.usersAjaxUserDeleteInformation = appn.emptyString;
                        this.showGroup = appn.emptyString;
                    }
                }
                let _initArgs;
                let _selectedItems;
                let _dataTable = null;
                let _cycle = 0;
                function init(args) {
                    _initArgs = args;
                    appn.userGroupFilter.init(_initArgs.usersIndex);
                    createDataTable();
                    addEvents();
                    if (appn.utils.hasValue(_initArgs.showGroup)) {
                        const link = $(`a.appnUserGroupFilter-link i[data-modal-iframe*="${_initArgs.showGroup}"]`);
                        if (link)
                            link.trigger('click');
                    }
                }
                index_1.init = init;
                function addEvents() {
                    $(document).on('change', '.appnGlobalConfirmDelete input[id^="user_"]', function () {
                        const userIdsToMassDelete = [];
                        $('.appnGlobalConfirmDelete input[id^="user_"]').each(function (index, checkBox) {
                            const isChecked = $(checkBox).prop('checked');
                            if (isChecked) {
                                const id = $(checkBox).attr('id').split('_')[1];
                                userIdsToMassDelete.push(id);
                            }
                        });
                        $('#usersToMassDelete').val(userIdsToMassDelete.join(','));
                    });
                    $(document).on('click', '.dataTables_scrollHeadInner th.sorting:first', function () {
                        let styleTag = $("#dynamic-style");
                        if (styleTag.length === 0) {
                            styleTag = $('<style>')
                                .prop('id', 'dynamic-style')
                                .prop('type', 'text/css')
                                .appendTo("head");
                        }
                        if (_cycle === 3)
                            _cycle = 0;
                        else
                            _cycle++;
                        let colorVar = _cycle > 1 ? '--datatable-sort-color-alt' : '--datatable-sort-color-default';
                        $('html').css('--datatable-sort-color', `var(${colorVar})`);
                        styleTag.html(`
                table.dataTable thead > tr > th.sorting_asc::after,
                table.dataTable thead > tr > th.sorting_desc::after {
                    color: var(--datatable-sort-color) !important;
                }
            `);
                        $('#sCustom_3').val(_cycle);
                    });
                    $(document).on('click', '.dataTables_scrollHeadInner th.sorting:nth-child(n+3)', function () {
                        $("#dynamic-style").remove();
                        _cycle = 0;
                        $('#sCustom_3').val(_cycle);
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(1, 0, 3),
                        sAjaxSource: 'Users/DataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: appn.userGroupFilter.getStateOrDefault().value }, appn.dataTable.getStateOrDefault('sCustom_1', $('#sCustom_1').val()), appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()), appn.dataTable.getStateOrDefault('sCustom_3', $('#sCustom_3').val()));
                        },
                        autoWidth: false,
                        scrollX: '100%',
                        aaSorting: [[1, 'asc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '27%' },
                            { bSortable: true, sWidth: '27%' },
                            { bSortable: true, sWidth: '15%' },
                            { bSortable: true, sWidth: '10%' },
                            { bSortable: true, sWidth: '15%' }
                        ],
                        fnInitComplete: function () {
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.userTypes, 'sCustom_2', 'saveMeState', 'ALL TYPES'));
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.userStatuses, 'sCustom_1', 'saveMeState'));
                            const head = $('.dataTables_scrollHeadInner th.sorting:first');
                            _cycle = 0;
                            if (head.attr('aria-sort') === 'descending')
                                _cycle = 1;
                            $('#sCustom_3').val(_cycle);
                            $('.dataTables_filter').prepend(appn.elementBuilder.createElement('input', 'saveMeState', 'sCustom_3', [['type', 'hidden'], ['value', $('#sCustom_3').val()]]));
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ], appn.requestUser.isUserOrHigher && _initArgs.userPermissionManageUsers, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher && _initArgs.userPermissionManageUsers);
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#addnew').click(function (e) {
                                e.preventDefault();
                                appn.location.navTo(_initArgs.usersCreate, [
                                    {
                                        name: 'groupId',
                                        value: appn.userGroupFilter.selectedGroupId
                                    }
                                ]);
                            });
                            $('#importusers').click(function (e) {
                                e.preventDefault();
                                $('#importDialog').modal('show');
                                return false;
                            });
                            $('#usersImportForm').submit(function (e) {
                                e.preventDefault();
                                appn.hasFormSubmitAlreadyHappened = false;
                                appn.ajax.post({
                                    url: $('#usersImportForm').attr('action'),
                                    data: new FormData(this),
                                    contentType: false,
                                    processData: false,
                                    done: function () {
                                        appn.ui.showImportConfirmation('Users');
                                        appn.notifications.updateNotificationTotal();
                                    },
                                    fail: function (jqXHR, textStatus, errorThrown) {
                                        appn.toast.notify(appn.toast.Type.error, T('User import failed.'));
                                    },
                                    always: function () {
                                        appn.dialog.hide();
                                        appn.dialog.hideLoading();
                                    }
                                });
                            });
                            $('#exportUsers').off().on('click', function (event) {
                                event.preventDefault();
                                $('#dialog-exportUsers').modal('show');
                            });
                            $('#exportUsersDialogButton').off().on('click', function (event) {
                                event.preventDefault();
                                appn.ajax.get({
                                    url: _initArgs.exportUserRows,
                                    data: {
                                        isProtectData: $('#ExportSettings_AnonymizePersonalData').is(':checked'),
                                        includeUserAudits: $('#ExportSettings_IncludeUserAudits').is(':checked')
                                    },
                                    done: function () {
                                        parent.appn.notifications.updateNotificationTotal();
                                        $('#dialog-exportUsers').modal('hide');
                                        appn.ui.showExportConfirmation('Users');
                                    }
                                });
                            });
                            $('#manageBtn').click(function (e) {
                                e.preventDefault();
                                appn.dialog.showContentSpinner($('#manageUsersDialog'));
                                if (!$(this).prop('disabled')) {
                                    _selectedItems = $('.selectRow:checked');
                                    let userIds = appn.emptyString;
                                    $(_selectedItems).map(function () {
                                        userIds += $(this).attr('id') + ',';
                                    });
                                    $('#usersToManage').val(userIds);
                                    $('#manageUsersDialog').modal('show');
                                    const submitButton = $('#manageUsersDialog .card-header button[value="Delete"].btn-tool-danger');
                                    createDeleteMessageFromTable(submitButton, _selectedItems);
                                }
                            });
                            appn.dataTable.addSearchPlaceholder(T(`Filter results where the User's <b>Email, First Name, Last Name, External Id or Status</b> contains a keyword entered here.`));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
                function createDeleteMessageFromTable(button, selectedRows) {
                    button.attr('data-deletedetail', appn.emptyString);
                    button.attr('data-deletemessage', appn.emptyString);
                    let loginIds = [];
                    const usersList = [];
                    if (selectedRows.length > 1) {
                        selectedRows.each(function (index, selected) {
                            usersList.push({
                                Id: Number($(selected).attr('id')),
                                FullName: undefined,
                                LoginId: $($(selected).closest('tr').find('td')[2]).text(),
                                Email: undefined,
                                Count: undefined,
                                FirstName: undefined,
                                LastName: undefined,
                                Status: undefined,
                                HasWebAccess: undefined,
                                Level: undefined,
                                Type: undefined,
                                ProviderId: appn.requestProvider.id
                            });
                        });
                        loginIds = usersList.map(u => u.LoginId);
                    }
                    else {
                        usersList.push({
                            Id: Number($(selectedRows[0]).attr('id')),
                            FullName: undefined,
                            LoginId: $($(selectedRows[0]).closest('tr').find('td')[2]).text(),
                            Email: undefined,
                            Count: undefined,
                            FirstName: undefined,
                            LastName: undefined,
                            Status: undefined,
                            HasWebAccess: undefined,
                            Level: undefined,
                            Type: undefined,
                            ProviderId: appn.requestProvider.id
                        });
                        loginIds = usersList.map(u => u.LoginId);
                    }
                    appn.ajax.post({
                        url: _initArgs.usersAjaxUserDeleteInformation,
                        dataType: 'json',
                        data: { userLoginIds: loginIds, requestingProviderId: appn.requestProvider.id },
                        done: function (userDetailLists) {
                            const userDetailsList = [];
                            userDetailLists.forEach(function (userDetailList, index, original) {
                                const topUser = userDetailList.filter((o, i, a) => {
                                    return o.ProviderId === appn.requestProvider.id;
                                })[0];
                                userDetailsList.push({
                                    Id: topUser.Id,
                                    FullName: `${topUser.LastName}, ${topUser.FirstName}`,
                                    LoginId: topUser.LoginId,
                                    Email: topUser.Email,
                                    Count: userDetailList.length,
                                    FirstName: topUser.FirstName,
                                    LastName: topUser.LastName,
                                    Status: topUser.Status,
                                    HasWebAccess: topUser.HasWebAccess,
                                    Level: topUser.Level,
                                    Type: topUser.Type,
                                    ProviderId: appn.requestProvider.id
                                });
                            });
                            if (!appn.utils.hasValue(userDetailsList)) {
                                button.attr('disabled', 'disabled');
                                return;
                            }
                            button.removeAttr('disabled');
                            let msg;
                            let removeAllMessage = appn.emptyString;
                            let userStat = appn.emptyString;
                            const ul = appn.elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
                            if (userDetailsList.length > 1) {
                                userDetailsList.forEach(function (user, index, original) {
                                    removeAllMessage = appn.emptyString;
                                    if (user.Count > 1 && _initArgs.canSeeCheckboxes) {
                                        const hint = buildHint(user.Level);
                                        const text = _initArgs.providerType === 'Vendor' ? 'Remove user from all associated clients' : _initArgs.providerType === 'Enterprise' ? 'Remove user from all associated environments' : appn.emptyString;
                                        userStat = _initArgs.providerType === 'Vendor' ? '(<b>{0}</b> associated clients)' : _initArgs.providerType === 'Enterprise' ? '(<b>{0}</b> associated environments)' : appn.emptyString;
                                        if (hint.hasValue() && text.hasValue())
                                            removeAllMessage = appn.elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                                    }
                                    const li = appn.elementBuilder.createElement('li', undefined, undefined, undefined, `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : appn.emptyString}</p>${removeAllMessage.hasValue() ? removeAllMessage : appn.emptyString}`);
                                    ul.appendChild(li);
                                });
                                msg = T('The following <b>Users</b> and all their associated data will be permanently deleted.') + ul.outerHTML;
                            }
                            else {
                                const user = userDetailsList[0];
                                if (user.Count > 1 && _initArgs.canSeeCheckboxes) {
                                    const hint = buildHint(user.Level);
                                    const text = _initArgs.providerType === 'Vendor' ? 'Remove user from all associated clients' : _initArgs.providerType === 'Enterprise' ? 'Remove user from all associated environments' : appn.emptyString;
                                    userStat = _initArgs.providerType === 'Vendor' ? '(<b>{0}</b> associated clients)' : _initArgs.providerType === 'Enterprise' ? '(<b>{0}</b> associated environments)' : appn.emptyString;
                                    if (hint.hasValue() && text.hasValue())
                                        removeAllMessage = appn.elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                                }
                                msg = `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : appn.emptyString}` + T(' and all their associated data will be permanently deleted.') + `</p>${removeAllMessage.hasValue() ? removeAllMessage : appn.emptyString}`;
                            }
                            const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                            const msgWarning = T('The selected item(s) will be <b>permanently deleted</b> with <b>no option</b> to recover this data.');
                            const p2 = appn.elementBuilder.createElement('p', 'mt-4', undefined, undefined, msgWarning);
                            button.attr('data-deletedetail', JSON.stringify(p.outerHTML));
                            button.attr('data-deletemessage', p2.outerHTML);
                        },
                        always: function () {
                            appn.dialog.removeContentSpinner($('#manageUsersDialog'));
                        }
                    });
                }
                function buildHint(level) {
                    const clientHint = T('This user is has {0} access and the organization is a client of a Vendor. Check the box to remove this user from all client accounts linked with this Vendor. If you continue without removing this user from all other clients, you may incur additional user license fees.', level === AccessLevel.VendorAdmin ? 'Vendor Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : appn.emptyString);
                    const enviroHint = T('This user is has {0} access and the organization is part of an Enterprise Toolkit. Check the box to remove this user from all environments. If you continue without removing this user from all other environments, you may incur additional user license fees.', level === AccessLevel.EnterpriseAdmin ? 'Enterprise Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : appn.emptyString);
                    return _initArgs.providerType === 'Vendor' ? clientHint : _initArgs.providerType === 'Enterprise' ? enviroHint : appn.emptyString;
                }
                let AccessLevel;
                (function (AccessLevel) {
                    AccessLevel[AccessLevel["ReadOnly"] = 10] = "ReadOnly";
                    AccessLevel[AccessLevel["User"] = 20] = "User";
                    AccessLevel[AccessLevel["Admin"] = 30] = "Admin";
                    AccessLevel[AccessLevel["EnterpriseAdmin"] = 40] = "EnterpriseAdmin";
                    AccessLevel[AccessLevel["VendorAdmin"] = 50] = "VendorAdmin";
                    AccessLevel[AccessLevel["SuperAdmin"] = 99] = "SuperAdmin";
                })(AccessLevel || (AccessLevel = {}));
            })(index = users.index || (users.index = {}));
        })(users = views.users || (views.users = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
